var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapFill = function SvgMapFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.8 4.22 5.58 2.6l3.24 1.62 3.403-1.459a.27.27 0 0 1 .377.248v8.77L8.82 13.4l-3.24-1.62-3.404 1.46a.27.27 0 0 1-.344-.121.3.3 0 0 1-.032-.128z"
  })));
};
export default SvgMapFill;